import script from "./online-classification-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./online-classification-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__